import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { LoginComponent } from './core/login/login.component';
import { CodeComponent } from './core/code.component';
import { PsmsComponent } from './modules/psms/psms.component';
import { PsmsUsersComponent } from './modules/users/psms-users/psms-users.component';
import { PsmsRolesComponent } from './modules/users/psms-users/psms-roles/psms-roles.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: 'code',
                component: CodeComponent
            },
            {
                path: 'login',
                component: LoginComponent
            },  
     
      
            {
                path: 'app-admin-profile',
                loadChildren: './modules/users/admin-profile/admin-profile.module#AdminProfileModule'
            },            
            // {
            //     path: 'app-admin-bmpage',
            //     loadChildren: './modules/users/admin-bmpage/admin-bmpage.module#AdminBMPageModule'
            // }, 
            {
                path: 'app-admin-users',
                loadChildren: './modules/users/admin-users/admin-users.module#AdminUserModule'
            },
            {
                path: 'app-admin-roles',
                loadChildren: './modules/users/admin-roles/admin-roles.module#AdminRoleModule'
            },
            {
                path: 'app-master-data-setup',
                loadChildren: './modules/consecrated/master-data-setup/master-data-setup.module#MasterDataSetupModule'
            },            
            {
                path: 'app-setting',
                loadChildren: './modules/common/settings/settings.module#SettingComponentModule'
            },
            {
                path: 'app-associate-type',
                loadChildren: './modules/common/associates/associate-type.module#AssociateTypeModule'
            },
            {
                path: 'app-reports',
                loadChildren: './modules/common/reports/reports.module#ReportModule'
            },
            {
                path: 'app-fingerprint-type',
                loadChildren: './modules/fingerprint/fingerprint-summary/fingerprint-type.module#FingerprintTypeModule'
            },
            {
                path: 'app-seminarian',
                loadChildren: './modules/seminarian/seminarian.module#SeminarianModule'
            },
            {
                path: 'app-psms',
                loadChildren: './modules/psms/psms.module#PsmsModule'
            },
            {
                path: 'app-psms-users',
                
                loadChildren: './modules/users/psms-users/psms-users.module#PsmsUsersModule'
            },     
            //  { path: 'app-psms-users', loadChildren: () => import('./modules/users/psms-users/psms-users.module').then(m => m.PsmsUsersModule) },
           
           
            {
                path: 'app-priest',
                loadChildren: './modules/priest/priest.module#PriestModule'
            },
            {
                path: 'app-master-data-setup',
                loadChildren: './modules/common/master-data-setup/master-data-setup.module#MasterDataSetupModule'
            }, 
            {
                path: 'app-studentipm',
                loadChildren: './modules/studentipm/studentipm.module#StudentipmModule'
            },
            {
                path: 'app-humanresource',
                loadChildren: './modules/hr/humanresource.module#HumanresourceModule'
            },
            {
                path: 'app-deacon',
                loadChildren: './modules/deacon/deacon.module#DeaconModule'
            },
         


        ],
            {
                useHash: true,
                enableTracing: false,
                preloadingStrategy: PreloadAllModules,
                onSameUrlNavigation: 'reload'

            },

        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
